import { useQuery } from '@tanstack/react-query';
import { getAuditReportPackScope } from 'services/auditService';
import type { AuditReportPackScopeResponse } from 'services/auditService';
import type { CurrentInventoryPackScopeQueryParams } from '../../utils/currentInventoryPackScopeQuery';

type UseCurrentInventoryPackScopeOptions = {
  enabled?: boolean;
};

const emptyPackScope = (): AuditReportPackScopeResponse => ({
  store_id: '',
  metric: 'opening',
  pack_count: 0,
  packs: [],
  report_date: null,
  start_date: null,
  end_date: null,
  audit_id: null,
});

export function useCurrentInventoryPackScope(
  storeId?: string,
  params?: CurrentInventoryPackScopeQueryParams | null,
  options: UseCurrentInventoryPackScopeOptions = {}
) {
  const queryResult = useQuery<AuditReportPackScopeResponse, Error>({
    queryKey: ['audit-report-pack-scope', storeId, params],
    queryFn: async () => {
      if (!storeId || !params) {
        return emptyPackScope();
      }

      const response = await getAuditReportPackScope(storeId, params);
      if (response) {
        return response;
      }

      throw new Error('Failed to load selected pack list');
    },
    staleTime: 5 * 60 * 1000,
    enabled: Boolean(storeId && params && options.enabled !== false),
  });

  return {
    packScope: queryResult.data ?? null,
    isLoading: queryResult.isLoading,
    isFetching: queryResult.isFetching,
    isError: queryResult.isError,
    error: queryResult.error ?? null,
  };
}

